"use client";

import { ApolloLink, HttpLink, setLogVerbosity } from "@apollo/client";
import {
    ApolloNextAppProvider,
    ApolloClient,
    InMemoryCache,
    SSRMultipartLink,
} from "@apollo/client-integration-nextjs";
import Config from './../config';
setLogVerbosity("debug")
function makeClient() {
    const httpLink = new HttpLink({
        uri: (process.env.NODE_ENV === 'development' ? Config.graphql.development : Config.graphql.production),
    });

    return new ApolloClient({
        cache: new InMemoryCache(),
        link:
            typeof window === "undefined"
                ? ApolloLink.from([
                      new SSRMultipartLink({
                          stripDefer: true,
                      }),
                      httpLink,
                  ])
                : httpLink,
    });
}

export function ApolloWrapper({ children }: React.PropsWithChildren) {
    return (
        <ApolloNextAppProvider makeClient={makeClient}>
            {children}
        </ApolloNextAppProvider>
    );
}